import React, { useState, useEffect, useRef, useContext } from 'react';
import { SaveRounded } from "@mui/icons-material";
import { useNavigate, useParams } from 'react-router-dom';
import { genericPost } from '../../../services/authServices';
import { Formik, Form } from 'formik';
import * as Yup from 'yup';
import { Box, Grid, CircularProgress, CardHeader, Button, FormLabel, } from '@mui/material';
import CustomTextField from "../../common/CustomTextField";
import CustomButton from "../../common/CustomButton";
import CustomAutocomplete from "../../common/CustomAutoComplete";
import CustomTextarea from "../../common/CustomTextarea";
import Typography from '@mui/material/Typography';
import { Card, Divider, } from '@mui/material';
import { CREATE_SHIPPING_TRACKER, LIST_BL_DRAFTS_EXPORT, LIST_SHIPPING_TRACKER, LIST_IMPORT_SHIPPING_BOOKINGS } from '../../../services/apiRoutes';
import { getCommanExportShipmentId, getshippingStatus } from '../../../services/CommonServices';
import SailingOutlinedIcon from '@mui/icons-material/SailingOutlined';
import LocalShippingOutlinedIcon from '@mui/icons-material/LocalShippingOutlined';
import PlaceOutlinedIcon from '@mui/icons-material/PlaceOutlined';
import DirectionsBoatOutlinedIcon from '@mui/icons-material/DirectionsBoatOutlined';
import PrecisionManufacturingOutlinedIcon from '@mui/icons-material/PrecisionManufacturingOutlined';
import AirlineStopsOutlinedIcon from '@mui/icons-material/AirlineStopsOutlined';
import WarehouseOutlinedIcon from '@mui/icons-material/WarehouseOutlined';
import HourglassEmptyOutlinedIcon from '@mui/icons-material/HourglassEmptyOutlined';
import Stepper from '@mui/material/Stepper';
import Step from '@mui/material/Step';
import StepLabel from '@mui/material/StepLabel';
import StepContent from '@mui/material/StepContent';
import CustomLoader from '../../common/CustomLoader';
import { AuthContext } from '../../../context/AuthContext';
import MessageBox from '../../common/CustomMessageBox';
import { useExportShipmentDetails } from './Hook/useExportShipmentDetails';
import { useCompanyDateFormat } from "../../../constants/useCompanyDateFormat";
import { t } from '../../../constants/translationHelper';

const ValidationSchema = Yup.object().shape({
    date: Yup.string().required('date is required'),
    status: Yup.number().required('status is required'),
    exportBLNo: Yup.number().required('BL is required'),
    shippingBookingId: Yup.string().required("Booking is required"),
});

export default function ExportTracker({ fetchButtonList }) {
    const { token } = useContext(AuthContext)
    const companyDateFormat = useCompanyDateFormat();
    const [activeStep, setActiveStep] = React.useState(0);
    const [data, setData] = useState([]);
    const [shippingStatus, setshippingStatus] = useState([]);
    const [bookingList, setBookingList] = useState([]);
    const [selectedBooking, setSelectedBooking] = useState(null);
    const { exportShipmentId } = useParams();
    const { shipmentDetails, loading: shipmentLoading } = useExportShipmentDetails(exportShipmentId);

    const [message, setMessage] = useState({
        open: false,
        text: '',
        type: ''
    });
    const [error, setError] = useState(null);
    const [blList, setBlList] = useState([]);
    const [selectedExporttBLNo, setSelectedExporttBLNo] = useState(null);
    const [loading, setLoading] = useState(false);
    const [open, setOpen] = React.useState(true);
    const [leadModal, setLeadModal] = useState(false);
    const [activeTab, setActiveTab] = React.useState('Tracker');
    const navigate = useNavigate();
    let supplierId;
    const hasFetched = useRef(false);
    useEffect(() => {
        if (blList.length > 0 && !selectedExporttBLNo) {
            const lastItem = blList[blList.length - 1];
            setSelectedExporttBLNo(lastItem);
            fetchData(lastItem.id);
        }
    }, [blList]);
    useEffect(() => {
        if (shipmentDetails) {
            supplierId = shipmentDetails.supplierId;
            fetchData();
            getCommonData();
            fetchDataBlList();
            bookingFetchData();
            hasFetched.current = true;
        }
    }, [shipmentDetails, token]);
    const [formData] = useState({
        date: '',
        status: '',
        exportBLNo: '',
        notes: '',
        shippingBookingId: "",
    });
    if (!shipmentDetails) {
        return <p>  <CustomLoader open={shipmentLoading} />  </p>;
    }
    const getCommonData = async () => {
        const shippingStatus = await getshippingStatus();
        setshippingStatus(shippingStatus);
    }
    const handleClose = () => {
        setLeadModal(false)
    }
    const clientCompanyId = shipmentDetails.customerId;
    const shipmentId = shipmentDetails.shipmentId;
    const shipmentOrgId = shipmentDetails.exportShipmentId;
    const fetchDataBlList = async () => {
        setLoading(true);
        try {
            const payload = {
                clientCompanyId: clientCompanyId,
                shipmentId: shipmentId,
            };
            const response = await genericPost(LIST_BL_DRAFTS_EXPORT, payload);
            if (response.data.success) {
                const blDrafts = response.data.data.map((draft, index) => {
                    return {
                        id: draft.blDraftId || '',
                        title: draft.blNumber || '',
                    };
                });
                setBlList(blDrafts);
            } else {
                setError('No BL drafts found');
            }
        } catch (error) {
            setError('Error fetching BL drafts');
            console.error('Error fetching BL drafts', error);
        } finally {
            setLoading(false);
        }
    };
    const handleSubmit = async (values, { setSubmitting, resetForm }) => {
        try {
            const payload = {
                clientCompanyId: clientCompanyId,
                date: values.date,
                status: values.status,
                notes: values.notes,
                exportBLNo: values.exportBLNo,
                shipmentId: shipmentId,
                shipmentOrgId: shipmentOrgId,
                commanShipmentId: getCommanExportShipmentId,
                shippingBookingId: values.shippingBookingId,
            };

            const response = await genericPost(CREATE_SHIPPING_TRACKER, payload);
            if (response.status === 201) {
                setMessage({
                    open: true,
                    text: response?.data?.message || "Shipment Tracker successfully",
                    type: "success",
                });
                setTimeout(() => {
                    fetchData(values.exportBLNo);
                    handleClose();
                    fetchButtonList();
                }, 1000);
                resetForm();
                setSelectedBooking(null);
                setActiveStep(0);
            } else {
                alert('Something went wrong');
            }
        } catch (error) {
            alert('Something went wrong');
        } finally {
            setSubmitting(false);
        }
    };
    const bookingFetchData = async () => {
        setLoading(true);
        try {
            const payload = {
                clientCompanyId: clientCompanyId,
                commanShipmentId: getCommanExportShipmentId,
                shipmentId: shipmentId,
            };
            const response = await genericPost(
                LIST_IMPORT_SHIPPING_BOOKINGS,
                payload
            );
            if (response.data.success && response.data.shippingBooking) {
                const bookingData = response.data.shippingBooking.map((item) => ({
                    id: item.shippingBookingId,
                    title: item.bookingNumber,
                }));
                setBookingList(bookingData);
            } else {
                setBookingList([]);
            }
        } catch (err) {
            setBookingList([]);
            console.error(err);
        } finally {
            setLoading(false);
        }
    };
    const fetchData = async (exportBLNo, shippingBookingId = "") => {
        if (!exportBLNo) return;
        setLoading(true);
        try {
            const payload = {
                clientCompanyId: clientCompanyId,
                shipmentId: shipmentId,
                commanShipmentId: getCommanExportShipmentId,
                exportBLNo: exportBLNo,
                shippingBookingId: shippingBookingId,
            };
            const response = await genericPost(LIST_SHIPPING_TRACKER, payload);
            if (response.data.success && response.data.data) {
                const shippingMarkData = response.data.data.map((mark) => {
                    const matchingEvent = events.find(
                        event => event.shippingTrackerID === mark.shippingStatus?.shippingStatusId
                    );
                    return {
                        shippingTrackerID: mark.shippingTrackerID || "",
                        shippingBookingId: mark.booking?.shippingBookingId || "",
                        bookingNumber: mark.booking?.bookingNumber || "",
                        date: companyDateFormat(mark?.date) || "",
                        icon: matchingEvent ? matchingEvent.icon : null,
                        status: mark.shippingStatus?.title || "",
                        notes: mark.notes || "",
                        statusId: Number(mark.status),
                    };
                });
                setData(shippingMarkData);
            } else {
                setError('No shipping marks found');
            }
        } catch (error) {
            setError('Error fetching shipping marks');
            console.error('Error fetching shipping marks', error);
        } finally {
            setLoading(false);
        }
    };
    const events = [
        {
            shippingTrackerID: 1,
            icon: <LocalShippingOutlinedIcon />

        },
        {
            shippingTrackerID: 2,
            icon: <SailingOutlinedIcon />

        },
        {
            shippingTrackerID: 3,
            icon: <DirectionsBoatOutlinedIcon />

        },
        {
            shippingTrackerID: 4,
            icon: <PlaceOutlinedIcon />

        },
        {
            shippingTrackerID: 5,
            icon: <PrecisionManufacturingOutlinedIcon />

        },
        {
            shippingTrackerID: 6,
            icon: <AirlineStopsOutlinedIcon />

        },
        {
            shippingTrackerID: 7,
            icon: <WarehouseOutlinedIcon />

        },
        {
            shippingTrackerID: 8,
            icon: <HourglassEmptyOutlinedIcon />

        },
        {
            shippingTrackerID: 9,
            icon: <HourglassEmptyOutlinedIcon />

        },
    ];

    const newShippingStatus = shippingStatus.filter((status) => {
        if (!selectedBooking?.id) return true;
        return !data.some(
            (entry) =>
                Number(entry.shippingBookingId) === Number(selectedBooking.id) &&
                Number(entry.statusId) === Number(status.id)
        );
    });

    return (
        <>
            <div>
                <CustomLoader open={loading} />
                <Grid container spacing={2}>
                    <Grid item xs={6}>
                        <Card variant="outlined" sx={{ paddingLeft: "10px", paddingRight: "10px" }}>
                            <Grid container spacing={1} sx={{ paddingBottom: "5px", paddingTop: "10px" }}>
                                <Grid item xs={12} md={12}>
                                    <Typography sx={{ color: "#212529", fontWeight: 500, fontSize: "20px" }}>
                                        {t("Create Shipment Tracker")}
                                    </Typography>
                                </Grid>
                            </Grid>
                            <Divider />

                            <Box sx={{ mx: 'auto', mt: 0 }}>
                                <Formik
                                    initialValues={formData}
                                    validationSchema={ValidationSchema}
                                    onSubmit={handleSubmit}
                                >
                                    {({ isSubmitting, errors, touched, handleChange, setFieldValue, values }) => (
                                        <Form>
                                            <Grid container spacing={1}>
                                                <Grid item xs={12} md={6}>
                                                    <CustomAutocomplete
                                                        options={blList}
                                                        fieldLabel="Select BL No."
                                                        required={true}
                                                        getOptionLabel={(option) => option.title}
                                                        value={blList.find((option) => option.id === values.exportBLNo) || null}
                                                        onChange={(e, newValue) => {
                                                            setFieldValue('exportBLNo', newValue ? newValue.id : '');
                                                            setSelectedExporttBLNo(newValue);
                                                            if (newValue) fetchData(newValue.id);
                                                            else fetchData('');
                                                        }}
                                                        placeholder="Select BL No."
                                                        error={touched.exportBLNo && !!errors.exportBLNo}
                                                        helperText={touched.exportBLNo && errors.exportBLNo}
                                                    />
                                                </Grid>
                                                <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                                                    <CustomTextField
                                                        placeholder="Enter Date"
                                                        type="date"
                                                        name="date"
                                                        fieldLabel="Date"
                                                        required={true}
                                                        value={values.date}
                                                        onChange={handleChange}
                                                        error={touched.date && !!errors.date}
                                                        helperText={touched.date && errors.date}
                                                    />
                                                </Grid>
                                                <Grid item xs={12} md={6}>
                                                    <CustomAutocomplete
                                                        options={bookingList}
                                                        fieldLabel="Booking"
                                                        required
                                                        getOptionLabel={(option) => option.title || ""}
                                                        value={selectedBooking}
                                                        onChange={(e, newValue) => {
                                                            setSelectedBooking(newValue);
                                                            setFieldValue(
                                                                "shippingBookingId",
                                                                newValue ? newValue.id : ""
                                                            );
                                                            setFieldValue("status", "");
                                                            fetchData(
                                                                values.exportBLNo,
                                                                newValue ? newValue.id : ""
                                                            );
                                                        }}
                                                        placeholder="Select Booking"
                                                        error={
                                                            touched.shippingBookingId &&
                                                            !!errors.shippingBookingId
                                                        }
                                                        helperText={
                                                            touched.shippingBookingId &&
                                                            errors.shippingBookingId
                                                        }
                                                    />
                                                </Grid>
                                                <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                                                    <CustomAutocomplete
                                                        options={newShippingStatus}
                                                        fieldLabel="Status"
                                                        required={true}
                                                        getOptionLabel={(option) => option.title}
                                                        value={newShippingStatus.find((option) => option.id === values.status) || null}
                                                        onChange={(e, newValue) =>
                                                            setFieldValue('status', newValue ? newValue.id : '')
                                                        }
                                                        placeholder="Select Status"
                                                        error={touched.status && !!errors.status}
                                                        helperText={touched.status && errors.status}
                                                    />
                                                </Grid>
                                                <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                                                    <CustomTextarea
                                                        name="notes"
                                                        fieldLabel="Note"
                                                        value={values.notes}
                                                        onChange={handleChange}
                                                        sx={{ height: "150px !important" }}
                                                        placeholder="Write a Notes .."
                                                    />
                                                </Grid>
                                                <Grid item xs={12} sm={12} md={12} lg={12} xl={12} container justifyContent="center">
                                                    <CustomButton
                                                        startIcon={<SaveRounded />}
                                                        title={isSubmitting ? <CircularProgress size={20} color="inherit" /> : "Save"}
                                                        size="small"
                                                        variant="contained"
                                                        type="submit"
                                                        disabled={isSubmitting}
                                                    />
                                                </Grid>
                                            </Grid>
                                        </Form>
                                    )}
                                </Formik>
                            </Box>
                        </Card>

                    </Grid>
                    <Grid item xs={6}>
                        <Card variant="outlined" sx={{ paddingLeft: "10px", paddingRight: "10px" }}>
                            <Grid
                                container
                                spacing={2}
                                alignItems="center"
                                justifyContent="space-between"
                                sx={{ py: 1 }}
                            >
                                <Grid
                                    item
                                    xs={12}
                                    md={8}
                                    sx={{
                                        display: "flex",
                                        flexWrap: "wrap",
                                        alignItems: "center",
                                        gap: 1,
                                    }}
                                >
                                    {blList.map((list) => (
                                        <Button
                                            key={list.id}
                                            variant="outlined"
                                            sx={{
                                                backgroundColor:
                                                    selectedExporttBLNo?.id === list.id
                                                        ? "#007bff"
                                                        : "#fff",
                                                color:
                                                    selectedExporttBLNo?.id === list.id
                                                        ? "#fff"
                                                        : "#007bff",
                                                textTransform: "capitalize",
                                                borderRadius: 1,
                                                border: "1px solid #007bff",
                                                height: 34,
                                                minWidth: 100,
                                                px: 2,
                                                "&:hover": {
                                                    backgroundColor:
                                                        selectedExporttBLNo?.id === list.id
                                                            ? "#007bff"
                                                            : "#f5f5f5",
                                                },
                                            }}
                                            onClick={() => {
                                                setSelectedExporttBLNo(list);
                                                fetchData(list.id);
                                            }}
                                        >
                                            {list.title}
                                        </Button>
                                    ))}
                                </Grid>

                                <Grid item xs={12} md={4}>
                                    <CustomAutocomplete
                                        options={bookingList}
                                        getOptionLabel={(option) => option.title || ""}
                                        value={selectedBooking}
                                        onChange={(e, newValue) => {
                                            setSelectedBooking(newValue);

                                            fetchData(
                                                selectedExporttBLNo?.id,
                                                newValue ? newValue.id : ""
                                            );
                                        }}
                                        placeholder="Select Booking"
                                    />
                                </Grid>
                            </Grid>
                            <Divider />
                            <Grid container spacing={1} sx={{ paddingBottom: "5px", paddingTop: "10px" }}>
                                <Grid item xs={12} md={12}>
                                    <Box display="flex" alignItems="flex-end">
                                        <Typography sx={{ color: "#212529", fontWeight: 500, fontSize: "20px" }}>
                                            {t("Shipment Tracker")}
                                        </Typography>
                                        <Typography
                                            sx={{
                                                fontSize: "12px", fontWeight: "bold", marginLeft: 1, mb: "2px",
                                                color: newShippingStatus.length > 0 ? "red" : "green",
                                            }}
                                        >
                                            {newShippingStatus.length > 0 ? "Incomplete" : "Complete"}
                                        </Typography>
                                    </Box>

                                </Grid>
                            </Grid>
                            <Divider />

                            <Box sx={{ maxWidth: 400, pr: 5, pl: 5 }}>
                                <Stepper activeStep={activeStep} orientation="vertical">
                                    {data.map((step, index) => (
                                        <Step key={step.label}>
                                            <StepLabel
                                                style={{
                                                    paddingLeft: "0px",
                                                    color: index === 0 ? "#007bff" : "inherit",
                                                    fontSize: "25px"
                                                }}
                                                icon={step.icon}
                                                onClick={() => setActiveStep(index)}
                                            >
                                                <CardHeader
                                                    sx={{ padding: 0 }}
                                                    title={
                                                        <Box
                                                            sx={{
                                                                display: "flex",
                                                                justifyContent: "space-between",
                                                                alignItems: "center",
                                                                width: "100%",
                                                            }}
                                                        >
                                                            <Typography
                                                                sx={{
                                                                    fontSize: "15px",
                                                                    fontWeight: 600,
                                                                    color:
                                                                        index === 0
                                                                            ? "#007bff"
                                                                            : "#212529",
                                                                }}
                                                            >
                                                                {step.status}
                                                            </Typography>

                                                            <Typography
                                                                sx={{
                                                                    fontSize: "12px",
                                                                    fontWeight: 500,
                                                                    color: "#666",
                                                                    background: "#f5f5f5",
                                                                    px: 1,
                                                                    py: 0.3,
                                                                    borderRadius: 1,
                                                                }}
                                                            >
                                                                {step.bookingNumber}
                                                            </Typography>
                                                        </Box>
                                                    }
                                                    subheader={
                                                        <Typography
                                                            sx={{
                                                                fontSize: "12px",
                                                                color:
                                                                    index === 0
                                                                        ? "#007bff"
                                                                        : "#777",
                                                            }}
                                                        >
                                                            {step.date}
                                                        </Typography>
                                                    }
                                                />
                                            </StepLabel>
                                            <StepContent style={{ marginTop: "-25px" }} sx={{ pt: 2 }}>
                                                <Typography style={{ fontSize: "12px", }}>
                                                    {step.notes}
                                                </Typography>
                                            </StepContent>
                                        </Step>
                                    ))}
                                </Stepper>
                            </Box>

                        </Card>
                    </Grid>
                </Grid>
            </div >
            <MessageBox
                open={message.open}
                onClose={() => setMessage({ ...message, open: false })}
                message={message.text}
                handleClose={() => setMessage({ ...message, open: false })}
                type={message.type}
            />
        </>
    );
}

